/*
  Rasteriza a 1ª página de um PDF em PNG.

  Existe porque a API de correção por IA aceita só png/jpeg/gif/webp — mandar o
  PDF direto faz ela responder 200 com a nota zerada e o erro escondido dentro do
  campo de texto, o que passaria por correção válida.

  Roda no navegador, no envio do aluno: é o único momento em que o arquivo original
  está em mãos sem precisar de rasterizador nativo no servidor.
*/

/*
  Escala do render. 2.0 dá ~1240x1754px numa folha A4 — resolução suficiente para
  o OCR ler letra manuscrita sem gerar um arquivo grande demais para o upload.
*/
const ESCALA = 2.0;

/* Acima disso o upload fica pesado em rede móvel; cai para JPEG, que a API aceita. */
const LIMITE_PNG_BYTES = 4 * 1024 * 1024;

export async function rasterizarPrimeiraPagina(arquivoPdf) {
  const pdfjsLib = await import("pdfjs-dist");

  pdfjsLib.GlobalWorkerOptions.workerSrc =
    `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

  const arrayBuffer = await arquivoPdf.arrayBuffer();
  const pdf = await pdfjsLib.getDocument(arrayBuffer).promise;
  const page = await pdf.getPage(1);

  const viewport = page.getViewport({ scale: ESCALA });

  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  canvas.width = viewport.width;
  canvas.height = viewport.height;

  /*
    Fundo branco antes de desenhar: o canvas nasce transparente e o PNG resultante
    ficaria com fundo preto ao ser achatado pelo OCR, arruinando o reconhecimento.
  */
  context.fillStyle = "#ffffff";
  context.fillRect(0, 0, canvas.width, canvas.height);

  await page.render({ canvasContext: context, viewport }).promise;

  let blob = await paraBlob(canvas, "image/png");

  if (blob && blob.size > LIMITE_PNG_BYTES) {
    const jpeg = await paraBlob(canvas, "image/jpeg", 0.9);
    if (jpeg) blob = jpeg;
  }

  if (!blob) {
    throw new Error("Não foi possível gerar a imagem da página");
  }

  const extensao = blob.type === "image/jpeg" ? "jpg" : "png";

  return new File([blob], `pagina1.${extensao}`, { type: blob.type });
}

const paraBlob = (canvas, tipo, qualidade) =>
  new Promise((resolve) => canvas.toBlob(resolve, tipo, qualidade));
